/**
 * End-to-end test detection.
 *
 * Various parts of the app change behaviour under e2e tests — disabling
 * third-party analytics (Mixpanel/HubSpot/FullStory/Datadog), suppressing the
 * timezone-confirmation dialog, mocking feature flags, and skipping the
 * platform-connection redirect. Playwright sets `window.__E2E__` via an init
 * script (see `tests/playwright/fixtures/test.ts`); prefer `isE2E()` over
 * reading the global directly.
 */
declare global {
  interface Window {
    __E2E__?: boolean;
  }
}

/** True when running under the e2e runner. */
export function isE2E(): boolean {
  return Boolean(window.__E2E__);
}
